import { useEffect } from 'react';
import AuthCode from 'react-auth-code-input';

const DEFAULT_CODE_LENGTH = 6;

export type MfaCodeFieldProps = {
    autoFocus?: boolean;
    error?: string;
    onChange?: (code: string) => void;
    onCodeFullyEntered?: (code: string) => void;
};

export const MfaCodeField = ({ autoFocus = true, ...props }: MfaCodeFieldProps) => {
    // this is a hack to override the styling of the plugin
    const updateFieldStyle = () => {
        const inputElements = document.querySelectorAll(
            '.two-fa-code-input-wrapper .container .input'
        );
        for (const i of inputElements) {
            const inputElement = i as HTMLInputElement;
            if (props.error) {
                inputElement.className = 'input grey incorrect';
            } else if (inputElement == document.activeElement) {
                inputElement.className = 'input blue';
            } else if (inputElement.value) {
                inputElement.className = 'input grey';
            } else {
                inputElement.className = 'input light-grey';
            }
        }
    };

    const disableAutocomplete = () => {
        const inputElements = document.querySelectorAll(
            '.two-fa-code-input-wrapper .container .input'
        );
        inputElements.forEach((input) => {
            const inputElement = input as HTMLInputElement;
            inputElement.autocomplete = 'new-password';
        });
    };

    // this is only to update component when the input changes
    // hack the styling of the input fields of the plugin
    useEffect(() => {
        updateFieldStyle();
    });

    useEffect(() => {
        disableAutocomplete();
    }, []);

    const renderError = () => {
        if (!props.error) {
            return null;
        }

        return <div className={'input-error-message'}>{props?.error}</div>;
    };

    return (
        <div className={'two-fa-code-input-wrapper two-fa-code-input'}>
            <AuthCode
                autoFocus={autoFocus}
                allowedCharacters="numeric"
                onChange={(combinedCode) => {
                    updateFieldStyle();
                    if (props.onChange) {
                        props.onChange(combinedCode);
                    }
                    if (combinedCode.toString().length >= DEFAULT_CODE_LENGTH) {
                        if (props.onCodeFullyEntered) {
                            props.onCodeFullyEntered(combinedCode);
                        }
                    }
                }}
                containerClassName="container"
                inputClassName="input"
            />
            {renderError()}
        </div>
    );
};
